import "./LoginPage.css";
import logo from "../../../src/botgurulogo.png";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import useAuthService from "../../services/AuthService";
import { useAuthContext } from "../Auth/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {
  ArrowLeft,
  Pencil,
  Rocket,
  X,
  XCircle,
  GraduationCap,
  Building2,
  Plus,
} from "lucide-react";
import PhoneInput from "react-phone-number-input";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../useAuth";
import { CustomSelect } from "../CustomStyling";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [signInError, setSignInError] = useState("");
  const [otpResendCount, setOtpResendCount] = useState(0);
  const [message, setMessage] = useState("");
  const resendOTPLimits = 5;
  const [shownSignIn, setShowSignIn] = useState(true);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isFocused, setIsFocused] = useState(false);
  const [showExtraFields, setShowExtraFields] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const location = useLocation();
  const [isUnivStudent, setIsUnivStudent] = useState(false);


  const authService = useAuthService();
  const { setUserObjId, setNewUser,setUserRole,userObjId ,setUserEmail} = useAuthContext();
  const navigate = useNavigate();

  const [jobsInput, setJobsInput] = useState("");
  const [skillsInput, setSkillsInput] = useState("");

  const [additionalDetailsStep, setadditionalDetailsStep] = useState(1);

  // ── NEW: registration step tracker (1 = details, 2 = professional status, 3 = education/additional) ──
  const [registrationStep, setRegistrationStep] = useState(1);
  const [professionalStatus, setProfessionalStatus] = useState(""); // "student" | "working"

  // ── NEW: student-specific education fields ──
  const [studentDetails, setStudentDetails] = useState({
    educationLevel: "",
    department: "",
    yearOfGraduation: "",
    currentSemester: "",
    cgpa: "",
    skills: [],
    certificates: [],
    projects: [],
  });
  const [workingProfessionalDetails, setWorkingProfessionalDetails] = useState({
    currentJobTitle: "",
    currentCompany: "",
    totalExperience: "",
  });

  const [errors, setErrors] = useState({
    first_name: false,
    last_name: false,
    phone_number: false,
    target_roles: "",
    skills: "",
  });

  const [details, setDetails] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: email,
    target_roles: [],
    skills: [],
    gender: "",
    age: "",
    education_level: "",
    major: "",
  });

  // Add this state at the top with other state declarations
const [studentErrors, setStudentErrors] = useState({
  educationLevel: false,
  department: false,
  yearOfGraduation: false,
  currentSemester: false,
  skills: false,
});

  const { isAuthenticated,univStudentInfo, profileCompleted, universityId   } = useAuth();

  // Add this near the top of the component, after state declarations
  const flushInput = (inputValue, setInputValue, listKey, setterFn, max = 6) => {
    const trimmed = inputValue.trim();
    if (trimmed && (setterFn === setStudentDetails 
        ? studentDetails.skills.length < max 
        : details[listKey].length < max)) {
        setterFn(prev => ({
            ...prev,
            [listKey]: [...(Array.isArray(prev[listKey]) ? prev[listKey] : []), trimmed]
        }));
        setInputValue("");
        return true;
    }
    setInputValue("");
    return false;
  };

  // const redirectUser = () => {
  //   // console.log("authenticated", isAuthenticated)
  //   if (isAuthenticated) {
  //     navigate(location?.state?.route ?? "/landingPage", {
  //       state: location.state ?? {},
  //     });
  //   }
  // };
  // const redirectUser = () => {
  //   if (!isAuthenticated) return;
  
  //   if (univStudentInfo === false) {
  //     // University student with incomplete profile
  //     setShowOtpInput(false);
  //     setShowSignIn(false);
  //     setShowDetailsForm(true);
  //     setProfessionalStatus("student");
  //     setRegistrationStep(3);
  //     setIsUnivStudent(true);
  //   } else {
  //     // univStudentInfo === true OR null → go to landing page
  //     navigate(location?.state?.route ?? "/landingPage", { state: location.state ?? {} });
  //   }
  // };

  const redirectUser = () => {
    if (!isAuthenticated) return;
  
    // University student with incomplete student info
    if (universityId && univStudentInfo === false) {
      showRegistration(3);
      setProfessionalStatus("student");
      setIsUnivStudent(true);
      return;
    }
  
    // Non-university user with incomplete profile
    if (!universityId && profileCompleted === false) {
      showRegistration(1);
      return;
    }
  
    navigate(location?.state?.route ?? "/landingPage", { state: location.state ?? {} });
  };


  useEffect(() => {
    redirectUser();
  }, [isAuthenticated]);

  const clientId =
    "30723097180-545sij1sc7uk340kct0jac9hu3ocauef.apps.googleusercontent.com";

  useEffect(() => {
    setOtpResendCount(0);
    setSignInError("");
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      resetData();
    }
  }, [isAuthenticated]);

  const showRegistration = (step) => {
    setShowOtpInput(false);
    setShowSignIn(false);
    setShowDetailsForm(true);
    setRegistrationStep(step);
  };

  const resetData = () => {
    setShowSignIn(true);
    setShowOtpInput(false);
    setShowDetailsForm(false);
    setEmail("");
    setOtp(new Array(6).fill(""));
    setOtpError("");
    setErrors("");
    setadditionalDetailsStep(1);
    setRegistrationStep(1);
    setProfessionalStatus("");
    setStudentDetails({
      educationLevel: "",
      department: "",
      yearOfGraduation: "",
      currentSemester: "",
      cgpa: "",
      skills: [],
      certificates: [""],
      projects: [""],
    });
    setDetails({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: email,
      target_roles: [],
      skills: [],
    });
    setErrors({
      first_name: false,
      last_name: false,
      phone_number: false,
      target_roles: "",
      skills: "",
    });
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setDetails((prev) => ({
      ...prev,
      email: event.target.value,
    }));
  };

  // Handle Microsoft Sign-In
  const msalConfig = {
    auth: {
      clientId: "50986f23-a91b-43fa-a22d-919bc5445601", // Replace with your Microsoft Client ID
      authority: "https://login.microsoftonline.com/common",
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  };

  const handleLoginResponse = (response) => {
    const isNew = response.new_user === "Y";
    const role = response.role || "";
    const email = response.user_email || "";
  
    localStorage.setItem("userRole", role);
    setUserRole(role);
  
    if (response.user_obj_id) {
      setUserObjId(response.user_obj_id);
      setNewUser(response.new_user);
    }
  
    setDetails(prev => ({
      ...prev,
      first_name: response.first_name || prev.first_name,
      last_name: response.last_name || prev.last_name,
      phone_number: response.phone_number || prev.phone_number,
      email: email || prev.email,
    }));
  
    // New user → always step 1
    if (isNew) {
      showRegistration(1);
      return;
    }
  

  // ── Existing user (new_user === "N") ──
    // University admin
    if (role === "university_admin") {
      setUserEmail(email);
      navigate("/admin/students");
      return;
    }
  
    // University student with incomplete info
    if (response.university_id && response.univ_student_info === false) {
      showRegistration(3);
      setProfessionalStatus("student");
      setIsUnivStudent(true);
      return;
    }
  
    // Non-university user with incomplete profile
    if (!response.university_id && response.profile_completed === false) {
      const hasBasicInfo = response.first_name && response.last_name && response.phone_number;
      showRegistration(hasBasicInfo ? 2 : 1);
      return;
    }
  
    navigate(location?.state?.route ?? "/landingPage", { state: location.state ?? {} });
  };

  const msalInstance = new PublicClientApplication(msalConfig);
  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await msalInstance.loginPopup({
        scopes: ["user.read", "email"],
        prompt: "select_account",
      });
      // console.log(loginResponse)

      if (loginResponse.account) {
        const useremail = loginResponse.account.username;
        const credential = loginResponse.idToken;
        const source = "m";
        // console.log("Microsoft Sign-In Success:", email);

        setDetails((prevDetails) => ({
          ...prevDetails,
          email: useremail,
        }));
        authService
          .googlesignup(useremail, credential, source, {})
          .then((response) => {
            if (response?.status === "error") {
              setSignInError(response.message || "Sign in failed. Please try again.");
              return;
            }

            handleLoginResponse(response);
            // console.log(response)
            // if (response && response.user_obj_id) {
            //   setUserObjId(response.user_obj_id);
            //   setNewUser(response.new_user);
            // }
            // if (response.new_user === "Y") {
            //   localStorage.setItem("userRole", response.role || "");
            //   setUserRole(response.role || "");
            //   setShowOtpInput(false);
            //   setShowSignIn(false);
            //   setShowDetailsForm(true);
            //   setRegistrationStep(1); // start at step 1
            // }

            // if (response.new_user === "N") {
            //   localStorage.setItem("userRole", response.role || "");
            //   setUserRole(response.role || "");
            //   if (response.role=== "university_admin") {
            //     setUserEmail(response.user_email||"")
            //     navigate("/admin/students");
            //   } else if (response.univ_student_info === true) {
            //     // University student with complete profile
            //     navigate(location?.state?.route ?? "/landingPage", { state: location.state ?? {} });
            //   } else if (response.univ_student_info === false) {
            //     // University student with incomplete profile — registration flow
            //     setShowOtpInput(false);
            //     setShowSignIn(false);
            //     setShowDetailsForm(true);
            //     setProfessionalStatus("student");
            //     setRegistrationStep(3);
            //     setIsUnivStudent(true);

            //     setDetails(prev => ({
            //       ...prev,
            //       first_name: response.first_name || prev.first_name,
            //       last_name: response.last_name || prev.last_name,
            //       phone_number: response.phone_number || prev.phone_number
            //     }));
            //   } else {
            //     // Regular user (not associated with university) — no univ_student_info field
            //     navigate(location?.state?.route ?? "/landingPage", { state: location.state ?? {} });
            //   }
            // }
          })
          .catch((err) => {
              const msg = err?.data?.message || err?.message || "Sign in failed. Please try again.";
              setSignInError(msg);
              console.log("error:", err);
          });
      }
    } catch (error) {
      // console.log("Microsoft Sign-In Failed:", error);
    }
  };

  const handleEmailSubmit = () => {
    setIsLoading(true);
    setOtpError("");
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setShowTooltip(false);
    if (!emailPattern.test(email)) {
      setShowTooltip(true);
      setIsLoading(false);
    } else {
      // Fetch the user's public IP address
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          const ipAddress = data.ip;

          // Initialize FingerprintJS to generate a unique device fingerprint
          FingerprintJS.load().then((fp) => {
            fp.get().then((result) => {
              const fingerprint = result.visitorId; // Unique device fingerprint

              authService
                .signup(email, ipAddress, fingerprint)
                .then((response) => {
                  if (response.message?.includes("Maximum login attempts exceeded")) {
                    setSignInError(response.message);
                    setShowSignIn(true);
                    setShowTooltip(false);
                    setShowOtpInput(false);
                    setShowDetailsForm(false);
                    return;
                  }
                  setShowSignIn(false);
                  setShowTooltip(false);
                  setShowOtpInput(true);
                  setShowDetailsForm(false);
                  setSignInError("");
                })
                .catch((err) => {
                  const message = err?.data?.message || "Something went wrong. Please try again.";
                  setSignInError(message);
                  setShowSignIn(true);
                  setShowTooltip(false);
                  setShowOtpInput(false);
                  setShowDetailsForm(false);
                })
                .finally(() => {
                  setIsLoading(false); // Stop loading
                });
            });
          });
        })
        .catch((error) => {
          console.error("Failed to fetch IP address:", error);
          setIsLoading(false);
        });
    }
  };

  // To handle google signin
  const handleLoginSuccess = (response) => {
    const credential = response?.credential || null;
    const userEmail = response?.credential
      ? JSON.parse(atob(response.credential.split(".")[1])).email
      : null;
    const source = "g";
    if (userEmail) {
      setDetails((prevDetails) => ({
        ...prevDetails,
        email: userEmail, // Update the email field in details
      }));

      authService
        .googlesignup(userEmail, credential, source)
        .then((response) => { 
          if (response?.status === "error") {
            setSignInError(response.message || "Sign in failed. Please try again.");
            return;
          }  
         
          handleLoginResponse(response);
        })
        .catch((err) => {
          const msg =  err?.data?.message ||err?.message|| "Sign in failed. Please try again.";
          setSignInError(msg);
          console.log("error:", err);
        });
    }
  };

  const handleLoginFailure = (error) => {
    console.log("Google Sign-In Failed:", error);
  };

  const inputRefs = useRef([]);

  // To handle OTP Submission
  const handleOtpSubmit = () => {
    setIsLoading(true);
    setOtpError("");
    const otpValue = otp.join("");
    const otpValueint = parseInt(otpValue, 10);
    if (!otpValue || otpValue.length !== 6) {
      setOtpError("Please enter a valid OTP");
      setIsLoading(false);
      return;
    }
    authService
      .verifySignin(email, otpValueint, {
        credentials: "include", // Add this line to include cookies
      })
      .then((data) => {
        console.log("verifySignin response:", data); // Debug: check what comes back
        // const token = document.cookie.includes("auth_token");
        // console.log("auth_token exits", token)
        // console.log(document.cookie);
        if (data && data.user_obj_id) {
          setUserObjId(data.user_obj_id);
          setNewUser(data.new_user);
        }
        if (data.message.includes("Invalid OTP")) {
          setOtpError(
            "The OTP you entered is invalid or expired.\nPlease try again!"
          );
          console.log("invalid otp");
          setIsLoading(false);
          return;
        }
        // 
        handleLoginResponse(data);

      })
      .catch((err) => {
        setOtpError(
          "The OTP you entered is invalid or expired.\nPlease try again!"
        );
        console.log("error:" + err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  // for backspace and removing otp
  const handleKeyDown = (element, index) => {
    if (element.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }

    if (element.key === "Enter" && index === 5 && otp[index] !== "") {
      handleOtpSubmit();
    }
  };

  const handleOtpPaste = (event) => {
    const pastedValue = event.clipboardData.getData("Text").replace(/\D/g, ""); // Remove non-numeric characters
    if (pastedValue.length === 6) {
      // If the pasted value has exactly 6 digits, update the OTP fields
      setOtp(pastedValue.split("").map((char) => char));
    } else {
      setOtpError("Please enter a valid 6-digit OTP.");
    }
  };

  const handleResendOTP = () => {
    if (otpResendCount < resendOTPLimits) {
      setOtpResendCount((prev) => prev + 1);
      setMessage(" Resending...");
      handleEmailSubmit();
      let timer1 = setTimeout(() => {
        setMessage(" ✅OTP Resent!");
        // Reset message after 3 seconds
        let timer2 = setTimeout(() => {
          clearTimeout(timer1);
          clearTimeout(timer2);
          setMessage("");
        }, 2000);
      }, 2000);
      setOtp(new Array(6).fill("")); // Reset OTP array
      setOtpError("");
    } else {
      setOtpError("Max-limits reached.");
    }
  };

  const handleOtpChange = (element, index) => {
    if (/^[0-9]$/.test(element.value) || element.value === "") {
      const otpCopy = [...otp];
      otpCopy[index] = element.value;
      setOtp(otpCopy);
      if (element.value !== "" && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleDetailsSubmit = (event) => {
    event.preventDefault();

    const newErrors = {
      first_name: !details.first_name,
      last_name: !details.last_name,
      phone_number: !details.phone_number,
    };

    setErrors(newErrors);

    // Only proceed with submission if there are no errors
    if (!Object.values(newErrors).includes(true)) {
      setRegistrationStep(2); // go to professional status
    }
  };

  const handlePhoneChange = (value) => {
    if (value) {
      const digitsOnly = value.replace(/\D/g, "");


      if (digitsOnly.length < 10) {
        setPhoneError("Phone number must be at least 10 digits");
        setErrors((prev) => ({
          ...prev,
          phone_number: true,
        }));
      }

      if (digitsOnly.length > 15) {
        setPhoneError("Please enter a valid phone number");
        setErrors((prev) => ({
          ...prev,
          phone_number: true,
        }));
      } else {
        setPhoneError("");
        setErrors((prev) => ({
          ...prev,
          phone_number: false,
        }));
      }
    } else {
      setPhoneError("");
      setErrors((prev) => ({
        ...prev,
        phone_number: !value, // Set to true if no value (for required field validation)
      }));
    }

    setDetails((prevDetails) => ({
      ...prevDetails,
      phone_number: value,
    }));
  };

  const handleDetailsChange = (e) => {
    setDetails({
      ...details,
      [e.target.name]: e.target.value,
    });
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    const body = {
      ...details,
      professional_status: professionalStatus,
      ...(professionalStatus === "student" 
        ? { student_details: studentDetails } 
        : { working_professional_details: workingProfessionalDetails }),
    };
    authService.saveUserDetails(body).then((data) => {
      console.log(data);
      if (data.status === 200) {
        navigate("/pricing");
      } else {
        console.log(data.status);
      }
    });
  };



  // ── NEW: handle student "Create Account" submit ──
  const handleStudentSubmit = (e,extraSkill) => {
    e.preventDefault();

    const allSkills = extraSkill 
    ? [...studentDetails.skills, extraSkill] 
    : studentDetails.skills;
    const validSkills = allSkills.filter(skill => skill.trim() !== "");


    // Validate required student fields
    const newStudentErrors = {
      educationLevel: !isUnivStudent && !studentDetails.educationLevel,
      department: !isUnivStudent && !studentDetails.department,
      yearOfGraduation: !isUnivStudent && !studentDetails.yearOfGraduation,
      currentSemester: !isUnivStudent && !studentDetails.currentSemester,
      skills: validSkills.length === 0,
    };

    setStudentErrors(newStudentErrors);

    // Check if there are any errors
    if (Object.values(newStudentErrors).includes(true)) {
      return; // Don't submit if there are errors
    }

    let baseDetails = { ...details };

    // When university student, don't send personal fields — backend already has them
    if (isUnivStudent) {
      const { first_name, last_name, phone_number, email, ...rest } = baseDetails;
      baseDetails = rest;
    }

    const studentPayload = isUnivStudent
    ? { skills: validSkills, cgpa: studentDetails.cgpa, certificates: studentDetails.certificates, projects: studentDetails.projects }
    : { ...studentDetails, skills: validSkills };
  

    const body = {
      ...baseDetails,
      user_obj_id:userObjId,
      professional_status: "student",
      student_details: studentPayload,
    };
    authService.saveUserDetails(body).then((data) => {
      console.log(data);
      if (data.status === 200) {
        navigate("/landingPage/assessmentBot");
      } else {
        console.log(data.status);
      }
    });
  };

  const handleCreateAccount = (e) => {
    e.preventDefault(); // Add this line here too
    console.log("handleCreateAccount called, skillsInput:", skillsInput, "skills:", studentDetails.skills);
    const trimmed = skillsInput.trim();
    const extraSkill = (trimmed && studentDetails.skills.length < 6) ? trimmed : null;
    // if (extraSkill) {
    //     setStudentDetails(prev => ({ ...prev, skills: [...prev.skills, trimmed] }));
    // }
    setSkillsInput("");
    handleStudentSubmit(e, extraSkill);
};


  const handleJobSkillChange = (e, name) => {
    let value = e.target.value.trim();
    if (value.length > 0 && details[e.target.name].length < 6) {
      setDetails((prev) => ({
        ...prev,
        [e.target.name]: [...prev[e.target.name], value],
      }));
      setErrors((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
      if (e.target.name === "target_roles") {
        setJobsInput("");
      } else {
        setSkillsInput("");
      }
      return;
    } else if (value.length > 0) {
      setErrors((prev) => ({
        ...prev,
        [e.target.name]: "You can add only upto 6.",
      }));
    }
  };

  // ── NEW: Step indicator component ──
  const StepIndicator = ({ totalSteps, currentStep }) => {
    return (
      <div className="step-indicator">
        {Array.from({ length: totalSteps }, (_, i) => {
          const stepNum = i + 1;
          return (
            <div key={stepNum} className="step-indicator-item">
              <div
                className={`step-circle ${
                  stepNum <= currentStep ? "step-active" : "step-inactive"
                }`}
              >
                {stepNum}
              </div>
              {stepNum < totalSteps && (
                <div
                  className={`step-line ${
                    stepNum < currentStep
                      ? "step-line-active"
                      : "step-line-inactive"
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  // Determine total steps based on professional status
  const getTotalSteps = () => {
    if (professionalStatus === "student") return 3;
    if (professionalStatus === "working") return 3; // step 3 = additional info flow
    return 3; // default show 3
  };

  // Check if we're in the "new user registration" flow (details form visible, not sign-in, not OTP)
  const isInRegistrationFlow = showDetailsForm && !showOtpInput && !shownSignIn;

  // For working professional: show the additional-information flow at step 3
  const isWorkingProfessionalStep3 =
    isInRegistrationFlow &&
    registrationStep === 3 &&
    professionalStatus === "working";

  return (
    <div className="loginPage">
      {!(
        showExtraFields &&
        !showDetailsForm &&
        !showOtpInput &&
        !shownSignIn
      ) ? (
        <>
          {" "}
          {(shownSignIn || showOtpInput) && (
            <div className="left-content">
              <img
                className="botguru-logo-image"
                src={logo}
                alt="Logo"
              />
              <h1 className="welcome-msg">
                Welcome!{" "}
                <p className="welcome-subtitle">
                  Success Starts Here...
                  <Rocket className="rocket-icon" />
                </p>
              </h1>
            </div>
          )}
          {shownSignIn && !showOtpInput && (
            <div className="right-content">
              <img
                className="botguru-logo-image-mobile"
                src={logo}
                alt="Logo"
              />
              <div className="right-content-container">
                <div className="login-titles">
                  <h1 className="sign-title">Login or Sign Up</h1>
                  <p className="login-welcome-message">
                    We'll send you an OTP code to log in. If this is your first
                    time, an account will be created automatically.{" "}
                  </p>
                  {signInError && (
                    <div
                      className="sign-in-error"
                      style={{ color: "red", marginBottom: "10px" }}
                    >
                      <img
                        className="warning"
                        src={"warning.svg"}
                        alt="Warning"
                      ></img>
                      {signInError}
                    </div>
                  )}
                </div>
                <div className="email-container">
                  <input
                    type="email"
                    placeholder="Enter email address"
                    className="email-input"
                    value={email}
                    onChange={handleEmailChange}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        handleEmailSubmit();
                      }
                    }}
                  />
                  <FontAwesomeIcon className="email-icon" icon={faEnvelope} />
                </div>
                {showTooltip && (
                  <span className="login-tooltip">
                    <img
                      className="warning"
                      src={"warning.svg"}
                      alt="Warning"
                    ></img>
                    Please enter a valid email address.
                  </span>
                )}

                <button
                  className="sign-in"
                  onClick={handleEmailSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="loading-text">Sending...</span>
                      <div className="login-spinner"></div>
                    </>
                  ) : (
                    "Send me the Code"
                  )}
                </button>
                <p className="terms-message">
                  By Signing in, you agree to our{" "}
                  <Link to="/terms-of-use">Terms of Service</Link> and{" "}
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </p>
                <hr></hr>
                <br></br>
                {/* Calling google auth provider to render google sign in Change clientID wherever required */}
                <div className="other-logins">
                  <span>Sign in with:</span>
                  <GoogleOAuthProvider clientId={clientId}>
                    <GoogleLogin
                      onSuccess={handleLoginSuccess}
                      onError={handleLoginFailure}
                      type="icon"
                      size="large"
                      theme="filled_blue"
                      // useOneTap
                    />
                  </GoogleOAuthProvider>
                  <div>
                    <button
                      className="login-with-microsoft-btn"
                      onClick={handleMicrosoftLogin}
                    >
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                        alt="Microsoft logo"
                      />
                      {/* <span>
                                    Sign in with Microsoft
                                    </span>  */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Page to input gmail for signin */}
          {showOtpInput && !showDetailsForm && !shownSignIn && (
            <div className="right-content">
              <img
                className="botguru-logo-image-mobile"
                src={logo}
                alt="Logo"
              />
              <div className="otp-header">
                {/* <button onClick={() => {setShowSignIn(true); 
                                            setShowOtpInput(false); 
                                            setShowDetailsForm(false); 
                                            setEmail("")
                                            setOtp(new Array(6).fill(""));
                                            ;}}
                                className='change-email'>
                            <ArrowLeft />
                            <span>Back</span>
                            </button> */}
                <FontAwesomeIcon className="otp-icon" icon={faEnvelope} />

                <span className="otp-title">
                  An email with the code has been sent to
                  <br></br>
                  <strong
                    className="otp-to-email"
                    onClick={() => {
                      setShowSignIn(true);
                      setShowOtpInput(false);
                      setShowDetailsForm(false);
                      setEmail("");
                      setOtp(new Array(6).fill(""));
                    }}
                  >
                    {email} <Pencil className="edit-email" />
                  </strong>
                </span>
                <br></br>

                <span>OTP is valid for 5 minutes</span>

                {otpError && (
                  <div className="otp-error" style={{ whiteSpace: "pre-line" }}>
                    {otpError}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                    margin: "20px",
                  }}
                >
                  {otp.map((data, index) => (
                    <input
                      key={index}
                      type="text"
                      id={`otp-input-${index}`}
                      name="otp"
                      maxLength="1"
                      className={`otp-field ${
                        otpError ? "otp-error-border" : ""
                      }`}
                      value={data}
                      onChange={(e) => handleOtpChange(e.target, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onFocus={(e) => e.target.select()}
                      onPaste={handleOtpPaste}
                      ref={(el) => (inputRefs.current[index] = el)}
                      style={{
                        width: "40px",
                        height: "40px",
                        textAlign: "center",
                        fontSize: "20px",
                      }}
                    />
                  ))}
                </div>
                <span>
                  <span
                    className="resend-code"
                    onClick={() => {
                      if (message.length) {
                        return;
                      }
                      handleResendOTP();
                    }}
                  >
                    {" "}
                    Resend OTP Code
                  </span>
                  {<span>{message}</span>}
                </span>

                <div className="confirm">
                  <button
                    className="otp-btn"
                    onClick={handleOtpSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="loading-text">Confirm OTP ...</span>
                        <div className="login-spinner"></div>
                      </>
                    ) : (
                      "Confirm OTP"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* For new Users registration and fill the details */}
          {isInRegistrationFlow && !isWorkingProfessionalStep3 && (
            <div className="full-content">
              <img
                className="botguru-logo-image-mobile"
                src={logo}
                alt="Logo"
              />
              <div className="details-box">
              {!isUnivStudent && (
                <div className="create-account-header">
                  <h2>Register Your Account</h2>
                  <p className="create-account-subtitle">
                    Step {registrationStep} of {getTotalSteps()}
                  </p>
                  <StepIndicator
                    totalSteps={getTotalSteps()}
                    currentStep={registrationStep}
                  />
                </div>
                )}
                {registrationStep === 1 && (
                  <>
                    <div className="step-content-animated">
                      <div className="step-section-title">
                        <h2>Personal Details</h2>
                      </div>
                      <form className="details-form login-form">
                        <div className="email-container">
                          <input
                            type="name"
                            name="first_name"
                            className={`name-input ${
                              errors.first_name ? "error-fields" : ""
                            }`}
                            placeholder="First Name"
                            value={details.first_name}
                            onChange={handleDetailsChange}
                            required
                          />
                        </div>
                        <div className="email-container">
                          <input
                            type="name"
                            name="last_name"
                            className={`name-input ${
                              errors.first_name ? "error-fields" : ""
                            }`}
                            placeholder="Last Name"
                            value={details.last_name}
                            onChange={handleDetailsChange}
                            required
                          />
                        </div>

                        <div className="email-container">
                          <input
                            type="emailname"
                            placeholder="Email address"
                            className={`email-input ${
                              showTooltip ? "error" : ""
                            }`}
                            value={details.email}
                            onFocus={(e) => e.target.blur()}
                          />
                          <FontAwesomeIcon
                            className="email-icon"
                            icon={faEnvelope}
                          />
                        </div>
                        <div
                          className={`phone-container ${
                            isFocused ? "focused" : ""
                          } ${errors.phone_number ? "error-fields" : ""}`}
                        >
                          <PhoneInput
                            type="phone"
                            placeholder="9876543210"
                            name="Phone Number"
                            onFocus={() => setIsFocused(true)}
                            value={details.phone_number}
                            onChange={handlePhoneChange}
                            required
                            defaultCountry="US"
                          />
                        </div>
                        {/* <div className='gender-container'>
                                <div className="gender-input-container">
                                    <input type="radio" name="gender" id="gender" value="male" className="gender-input" onChange={handleDetailsChange} />
                                    <label htmlFor="male">Male</label>
                                </div>
                                <div className="gender-input-container">            
                                <input type="radio" name="gender" id="gender" value="female" className="gender-input" onChange={handleDetailsChange} />
                                <label htmlFor="female">Female</label>
                                </div>
                            </div>
                            <div className='age-container'>
                                <input type="number" name="age" id="age" placeholder="Age" value={details.age} onChange={handleDetailsChange} className="age-input" />
                            </div> */}

                        {phoneError && details.phone_number ? (
                          <div className="register-error-message">
                            {phoneError}
                          </div>
                        ) : (
                          (errors.first_name ||
                            errors.last_name ||
                            errors.phone_number) && (
                            <div className="register-error-message">
                              Please fill in the highlighted required fields.
                            </div>
                          )
                        )}
                        <div className="confirm">
                          <button
                            className="submit-btn"
                            onClick={(event) => handleDetailsSubmit(event)}
                          >
                            Next
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                )}
                {registrationStep === 2 && (
                  <div className="step-content-animated">
                    <div className="step-section-title">
                      <h2>Professional Status</h2>
                    </div>
                    <div className="professional-status-options">
                      <div
                        className={`status-card ${
                          professionalStatus === "student"
                            ? "status-card-selected"
                            : ""
                        }`}
                        onClick={() => setProfessionalStatus("student")}
                      >
                        <div
                          className={`status-radio ${
                            professionalStatus === "student"
                              ? "status-radio-selected"
                              : ""
                          }`}
                        >
                          {professionalStatus === "student" && (
                            <div className="status-radio-dot" />
                          )}
                        </div>
                        <GraduationCap size={24} className="status-icon" />
                        <div className="status-text">
                          <span className="status-label">Student</span>
                          <span className="status-desc">
                            Currently pursuing education
                          </span>
                        </div>
                      </div>
                      <div
                        className={`status-card ${
                          professionalStatus === "working"
                            ? "status-card-selected"
                            : ""
                        }`}
                        onClick={() => setProfessionalStatus("working")}
                      >
                        <div
                          className={`status-radio ${
                            professionalStatus === "working"
                              ? "status-radio-selected"
                              : ""
                          }`}
                        >
                          {professionalStatus === "working" && (
                            <div className="status-radio-dot" />
                          )}
                        </div>
                        <Building2 size={24} className="status-icon" />
                        <div className="status-text">
                          <span className="status-label">
                            Working Professional
                          </span>
                          <span className="status-desc">
                            Currently employed
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="registration-buttons registration-buttons-dual">
                      <button
                        className="reg-btn reg-btn-secondary"
                        onClick={() => setRegistrationStep(1)}
                      >
                        Previous
                      </button>
                      <button
                        className="reg-btn reg-btn-primary"
                        disabled={!professionalStatus}
                        onClick={() => {
                          if (professionalStatus) {
                            setRegistrationStep(3);
                            if (professionalStatus === "working") {
                              // For working professional, enter the additional-information flow
                              setShowExtraFields(true);
                              setShowDetailsForm(false);
                              setShowSignIn(false);
                              setShowOtpInput(false);
                            } else {
                              setRegistrationStep(3);
                            }
                          }
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}

                {/* ═══ STEP 3 (Student): Education Details ═══ */}
                {registrationStep === 3 && professionalStatus === "student" && (
                  <div className="step-content-animated">
                  {isUnivStudent ? (
                        <div className="create-account-header">
                          <h2>Please enter the details to continue</h2>
                        </div>
                      ) : (
                        <div className="step-section-title education-title">
                          <h2>Education Details</h2>
                        </div>
                      )}
                    <form className="education-form ">
                    {!isUnivStudent && (
                    <>
                      <div className="edu-field">
                        <CustomSelect
                            label={
                              <>
                                Highest Degree <span style={{ color: 'red' }}>*</span>
                              </>
                            }
                          value={studentDetails.educationLevel}
                          onChange={(val) =>
                            setStudentDetails((prev) => ({
                              ...prev,
                              educationLevel: val,
                            }))
                          }
                          placeholder="Select level"
                          options={[
                            { value: "high_school", label: "High School" },
                            { value: "bachelors", label: "Bachelor's" },
                            { value: "masters", label: "Master's" },
                            { value: "phd", label: "PhD" },
                          ]}
                        />
                      </div>

                      <div className="edu-field">
                        <CustomSelect
                           label={
                            <>
                              Department <span style={{ color: 'red' }}>*</span>
                            </>
                          }
                          value={studentDetails.department}
                          onChange={(val) =>
                            setStudentDetails((prev) => ({
                              ...prev,
                              department: val,
                            }))
                          }
                          placeholder="Select department"
                          options={[
                            {
                              value: "computer_science",
                              label: "Computer Science",
                            },
                            {
                              value: "electrical",
                              label: "Electrical Engineering",
                            },
                            {
                              value: "mechanical",
                              label: "Mechanical Engineering",
                            },
                            { value: "civil", label: "Civil Engineering" },
                            {
                              value: "business",
                              label: "Business Administration",
                            },
                            { value: "arts", label: "Arts & Humanities" },
                            { value: "science", label: "Natural Sciences" },
                            { value: "other", label: "Other" },
                          ]}
                        />
                      </div>

                      <div className="edu-field">
                        <CustomSelect
                          label={
                            <>
                              Year of Graduation <span style={{ color: 'red' }}>*</span>
                            </>
                          }
                          value={studentDetails.yearOfGraduation}
                          onChange={(val) =>
                            setStudentDetails((prev) => ({
                              ...prev,
                              yearOfGraduation: val,
                            }))
                          }
                          placeholder="Select year"
                          scrollToValue={new Date().getFullYear().toString()}
                          options={Array.from({ length: 19 }, (_, i) => {
                            const currentYear = new Date().getFullYear();
                            const year = currentYear - 9 + i;
                            return { 
                              value: year.toString(), 
                              label: year === currentYear ? `${year} (Current)` : year.toString() 
                            };
                          })}
                        />
                      </div>

                      <div className="edu-field">
                        <CustomSelect
                          label={
                            <>
                              Current Semester <span style={{ color: 'red' }}>*</span>
                            </>
                          }
                          value={studentDetails.currentSemester}
                          onChange={(val) =>
                            setStudentDetails((prev) => ({
                              ...prev,
                              currentSemester: val,
                            }))
                          }
                          placeholder="Select semester"
                          options={[
                            { value: "1", label: "1st" },
                            { value: "2", label: "2nd" },
                            { value: "3", label: "3rd" },
                            { value: "4", label: "4th" },
                            { value: "5", label: "5th" },
                            { value: "6", label: "6th" },
                            { value: "7", label: "7th" },
                            { value: "8", label: "8th" },
                          ]}
                        />
                      </div>
                      </>
                      )}

                      <div className="edu-field">
                        <label className="edu-label">CGPA (0-10)</label>
                        <input
                          type="number"
                          className="edu-input"
                          placeholder="8.5"
                          min="0"
                          max="10"
                          step="0.1"
                          value={studentDetails.cgpa}
                          onChange={(e) =>
                            setStudentDetails((prev) => ({
                              ...prev,
                              cgpa: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="edu-field">
                        <div className="edu-label-row">
                          <label className="edu-label">Skills <span style={{ color: 'red' }}>*</span></label>
                        </div>
                        <div className="edu-input-row">
                          <input
                            type="text"
                            className="edu-input"
                            placeholder="Enter skills (e.g., React, Python, Machine Learning)"
                            value={skillsInput}
                            onChange={(e) => {
                              if (e.target.value.length > 30) {
                                setErrors((prev) => ({
                                  ...prev,
                                  skills:
                                    "Skill should be less than 30 characters",
                                }));
                              } else {
                                setSkillsInput(e.target.value);
                                setErrors((prev) => ({
                                  ...prev,
                                  skills: "",
                                }));
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const value = skillsInput.trim();
                                if (
                                  value.length > 0 &&
                                  studentDetails.skills.length < 6
                                ) {
                                  setStudentDetails((prev) => ({
                                    ...prev,
                                    skills: [...prev.skills, value],
                                  }));
                                  setSkillsInput("");
                                  setErrors((prev) => ({
                                    ...prev,
                                    skills: "",
                                  }));
                                } else if (value.length > 0) {
                                  setErrors((prev) => ({
                                    ...prev,
                                    skills: "You can add only up to 6.",
                                  }));
                                }
                              }
                            }}
                          />
                        </div>
                        <p
                          style={{
                            fontSize: "0.85rem",
                            color: "var(--text-secondary)",
                            margin: "0.3rem 0",
                          }}
                        >
                          Press Enter to add. You can add up to 6 skills.
                        </p>
                        {errors.skills && (
                          <p className="error" style={{ fontSize: "0.85rem" }}>
                            {errors.skills}
                          </p>
                        )}
                        {studentDetails.skills.length > 0 &&
                          studentDetails.skills.some((s) => s !== "") && (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "0.5rem",
                                marginTop: "0.5rem",
                              }}
                            >
                            {studentDetails.skills.map((skill, idx) =>
                              skill !== "" ? (
                                <div key={idx} className="edu-skill-tag">
                                  <span>{skill}</span>
                                  <X
                                    size={14}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setStudentDetails((prev) => ({
                                        ...prev,
                                        skills: prev.skills.filter((_, i) => i !== idx),
                                      }));
                                    }}
                                  />
                                </div>
                              ) : null
                            )}
                            </div>
                          )}
                      </div>

                      <div className="edu-field">
                        <div className="edu-label-row">
                          <label className="edu-label">Certificates</label>
                          <span
                            className="edu-add-btn"
                            onClick={() => {
                              if (studentDetails.certificates.length < 5) {
                                setStudentDetails((prev) => ({
                                  ...prev,
                                  certificates: [...prev.certificates, ""],
                                }));
                              }
                            }}
                          >
                            <Plus size={14} /> Add Certificate
                          </span>
                        </div>
                        {studentDetails.certificates.map((cert, idx) => (
                          <div key={idx} className="edu-input-row">
                            <input
                              type="text"
                              className="edu-input"
                              placeholder="e.g., AWS Certified Developer"
                              value={cert}
                              onChange={(e) => {
                                const updated = [
                                  ...studentDetails.certificates,
                                ];
                                updated[idx] = e.target.value;
                                setStudentDetails((prev) => ({
                                  ...prev,
                                  certificates: updated,
                                }));
                              }}
                            />
                            {studentDetails.certificates.length > 1 && (
                              <button
                                type="button"
                                className="edu-remove-btn"
                                onClick={() => {
                                  const updated =
                                    studentDetails.certificates.filter(
                                      (_, i) => i !== idx
                                    );
                                  setStudentDetails((prev) => ({
                                    ...prev,
                                    certificates: updated,
                                  }));
                                }}
                              >
                                <X size={16} />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>

                      <div className="edu-field">
                        <div className="edu-label-row">
                          <label className="edu-label">
                            Projects Worked On
                          </label>
                          <span
                            className="edu-add-btn"
                            onClick={() => {
                              if (studentDetails.projects.length < 5) {
                                setStudentDetails((prev) => ({
                                  ...prev,
                                  projects: [...prev.projects, ""],
                                }));
                              }
                            }}
                          >
                            <Plus size={14} /> Add Project
                          </span>
                        </div>
                        {studentDetails.projects.map((proj, idx) => (
                          <div key={idx} className="edu-input-row">
                            <textarea
                              className="edu-input"
                              placeholder="e.g., E-commerce Website with React"
                              value={proj}
                              onChange={(e) => {
                                const updated = [...studentDetails.projects];
                                updated[idx] = e.target.value;
                                setStudentDetails((prev) => ({
                                  ...prev,
                                  projects: updated,
                                }));
                              }}
                            />
                            {studentDetails.projects.length > 1 && (
                              <button
                                type="button"
                                className="edu-remove-btn"
                                onClick={() => {
                                  const updated =
                                    studentDetails.projects.filter(
                                      (_, i) => i !== idx
                                    );
                                  setStudentDetails((prev) => ({
                                    ...prev,
                                    projects: updated,
                                  }));
                                }}
                              >
                                <X size={20} />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    </form>
                    {(() => { console.log("studentErrors:", studentErrors, "isUnivStudent:", isUnivStudent, "skills:", studentDetails.skills, "skillsInput:", skillsInput); return null; })()}
                    {(studentErrors.skills || 
                        (!isUnivStudent && (
                          studentErrors.educationLevel || 
                          studentErrors.department || 
                          studentErrors.yearOfGraduation || 
                          studentErrors.currentSemester
                        ))
                      ) && (
                        <div className="register-error-message" style={{ marginTop: '1rem' }}>
                          Please fill in all required fields marked with *
                        </div>
                      )}
                   <div className="registration-buttons registration-buttons-dual">
                    {!isUnivStudent && (
                      <button
                        className="reg-btn reg-btn-secondary"
                        onClick={() => setRegistrationStep(2)}
                      >
                        Previous
                      </button>
                    )}
                    <button
                      className="reg-btn reg-btn-primary"
                      onClick={handleCreateAccount}
                    >
                      {isUnivStudent ? "Continue" : "Create Account"}
                    </button>
                  </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="additional-information">
            <img
              className="botguru-logo-image"
              src={logo}
              alt="Logo"
            />
            <div className="additional-info-container">
              <h1 className="additional-info-title">
                Elevate and Transform Your Profile
              </h1>
              <h2 className="additional-info-subtitle">
                For a truly personalized experience, share your career
                aspirations and background with BotGuru.
              </h2>

              {additionalDetailsStep === 1 && (
                <>
                  <div key="step1" className="additional-info-body">
                    <h1 className="body-h1">
                      What’s your highest education level?
                    </h1>
                    <CustomSelect
                      label="Highest Degree"
                      value={details.education_level}
                      onChange={(val) =>
                        setDetails((prev) => ({ ...prev, education_level: val }))
                      }
                      placeholder="Select degree"
                      options={[
                        { value: "bachelors", label: "Bachelor’s" },
                        { value: "masters", label: "Master’s" },
                        { value: "phd", label: "PhD" },
                      ]}
                      width="50%"
                    />

                    <h1 className="body-h1" style={{ marginTop: "2rem" }}>
                      What’s your major?
                    </h1>
                    <input
                      type="text"
                      name="major"
                      className="user-major-input"
                      placeholder="Enter your major"
                      value={details.major}
                      onChange={(e) =>
                        setDetails((prev) => ({
                          ...prev,
                          major: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="control-buttons">
                    <button
                      className="additional-details-btn"
                      onClick={() => {
                        setadditionalDetailsStep(2);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </>
              )}

              {additionalDetailsStep === 2 && (
                <>
                  <div key="step2" className="additional-info-body">
                    <h1 className="body-h1">
                      Which job roles or positions are you interested in?{" "}
                    </h1>
                    <input
                      type="text"
                      name="target_roles"
                      className="user-input"
                      value={jobsInput}
                      autoFocus
                      onChange={(e) => {
                        if (e.target.value.length > 30) {
                          setErrors((prev) => ({
                            ...prev,
                            target_roles:
                              "Job Role Should be less than 30 characters",
                          }));
                        } else {
                          setJobsInput(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            target_roles: "",
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleJobSkillChange(e);
                        }
                      }}
                      placeholder="Enter job roles (e.g. software engineer, data scientist, etc.)"
                    />
                    <p>
                      {" "}
                      Click Enter to add to the list. You can add Upto 6 job
                      roles.
                    </p>
                    {errors.target_roles && (
                      <p className="error">{errors.target_roles}</p>
                    )}
                    <div
                      className="user-data-container"
                      onClick={(event) => {
                        if (event.target.classList.contains("cancel")) {
                          const jobToRemove =
                            event.target.previousSibling.textContent;
                          setDetails((prev) => ({
                            ...prev,
                            target_roles: prev.target_roles.filter(
                              (job) => job !== jobToRemove
                            ),
                          }));
                        }
                      }}
                    >
                      {details.target_roles &&
                        details.target_roles.map((job, index) => (
                          <div key={index} className="user-input-item">
                            <p className="user-data-text">{job}</p>
                            <p className="cancel">x</p>
                            {/* <XCircle className="cancel"/> */}
                            {/* <FontAwesomeIcon icon={faTimesCircle} size="lg" className="cancel" /> */}
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="control-buttons">
                    <button
                      className="additional-details-btn"
                      onClick={() => {
                        setadditionalDetailsStep(1);
                      }}
                    >
                      Back
                    </button>
                    <button
                      className="additional-details-btn"
                      onClick={() => {
                        flushInput(jobsInput, setJobsInput, "target_roles", setDetails);
                        setadditionalDetailsStep(3);
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </>
              )}
              {additionalDetailsStep === 3 && (
                <>
                  <div key="step3" className="additional-info-body">
                    <h1 className="body-h1">
                      What are your key skills or areas of expertise?
                    </h1>
                    <input
                      type="text"
                      name="skills"
                      className="user-input"
                      value={skillsInput}
                      autoFocus
                      onChange={(e) => {
                        if (e.target.value.length > 30) {
                          setErrors((prev) => ({
                            ...prev,
                            skills: "Skill Should be less than 30 characters",
                          }));
                        } else {
                          setSkillsInput(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            skills: "",
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleJobSkillChange(e);
                        }
                      }}
                      placeholder="Enter Skills (e.g. Machine Learning, System Design, etc.)"
                    />
                    <p>
                      {" "}
                      Click Enter to add to the list. You can add Upto 6 job
                      related skills.
                    </p>
                    {errors.skills && <p className="error">{errors.skills}</p>}
                    <div
                      className="user-data-container"
                      onClick={(event) => {
                        if (event.target.classList.contains("cancel")) {
                          const skillToRemove =
                            event.target.previousSibling.textContent;
                          setDetails((prev) => ({
                            ...prev,
                            skills: prev.skills.filter(
                              (skill) => skill !== skillToRemove
                            ),
                          }));
                        }
                      }}
                    >
                      {details.skills &&
                        details.skills.map((skill, index) => (
                          <div key={index} className="user-input-item">
                            <p className="user-data-text">{skill}</p>
                            <p className="cancel">x</p>
                            {/* <XCircle className="cancel"/> */}
                            {/* <FontAwesomeIcon icon={faTimesCircle} size="lg" className="cancel" /> */}
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="control-buttons">
                    <button
                      className="additional-details-btn"
                      onClick={() => setadditionalDetailsStep(2)}
                    >
                      Back
                    </button>
                    <button
                      className="additional-details-btn"
                      onClick={() => {
                        flushInput(skillsInput, setSkillsInput, "skills", setDetails);
                        setadditionalDetailsStep(4);
                      }}
                    >
                      Next
                    </button>
                  </div>
                </>
              )}
              {additionalDetailsStep === 4 && (
                <>
                  <div key="step4" className="additional-info-body">
                    <h1 className="body-h1">What's your current job title?</h1>
                    <input
                      type="text"
                      name="currentJobTitle"
                      className="user-input"
                      placeholder="e.g., Senior Software Engineer"
                      value={workingProfessionalDetails.currentJobTitle}
                      onChange={(e) =>
                        setWorkingProfessionalDetails((prev) => ({
                          ...prev,
                          currentJobTitle: e.target.value,
                        }))
                      }
                    />

                    <h1 className="body-h1" style={{ marginTop: "2rem" }}>
                      Which company do you currently work for?
                    </h1>
                    <input
                      type="text"
                      name="currentCompany"
                      className="user-input"
                      placeholder="e.g., Google, Microsoft, Startup Name"
                      value={workingProfessionalDetails.currentCompany}
                      onChange={(e) =>
                        setWorkingProfessionalDetails((prev) => ({
                          ...prev,
                          currentCompany: e.target.value,
                        }))
                      }
                    />
                    <h1 className="body-h1"  style={{ marginTop: "2rem" }}>
                      How many years of total experience do you have?
                    </h1>
                    <input
                      type="number"
                      name="totalExperience"
                      className="user-input"
                      placeholder="e.g., 5"
                      min="0"
                      step="0.5"
                      value={workingProfessionalDetails.totalExperience}
                      onChange={(e) =>
                        setWorkingProfessionalDetails((prev) => ({
                          ...prev,
                          totalExperience: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="control-buttons">
                    <button
                      className="additional-details-btn"
                      onClick={() => setadditionalDetailsStep(3)}
                    >
                      Back
                    </button>
                    <button
                      className="additional-details-btn"
                      onClick={handleNextClick}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};